import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, ContextSwitchUtils, DirectiveUtils, ProfileService, ResourceControlService, SnackBarService, SpinnerService } from '@fidcare/fe-core';
import { StruttureService } from '@fidcare/hfm-api';
import { ButtonResponse, ButtonService, TabsService } from '@fidcare/hop-api';
import { environment } from 'environments/environment';
import jwt_decode from 'jwt-decode';
import { catchError, of, take } from 'rxjs';

@Component({
	selector: 'hop-home-page',
	templateUrl: './home-page.component.html',
	styleUrls: ['./home-page.component.scss']
})
export class HOPHomePage implements OnInit {

	buttons: ButtonResponse[];
	isLoading: boolean;
	userRoles: string[];

	pageTitle: "Homecare";

	private currentTimeInMillis: number | null = null;

	constructor(
		private readonly router: Router,
		private readonly authService: AuthService,
		private readonly buttonsService: ButtonService,
		private activatedRoute: ActivatedRoute,
		private _spinnerService: SpinnerService,
		private _snackbarService: SnackBarService,
		private _struttureService: StruttureService,
		private _profileService: ProfileService,
		private _rcsService: ResourceControlService,
		private _directiveUtils: DirectiveUtils,
		private _tabsService: TabsService
	) {
	}

	public get userDisplayName(): string {
		const profile = this._profileService.profile;

		return [
			profile?.firstName,
			profile?.lastName
		].filter(Boolean).join(' ');
	}

	public get structureName(): string {
		return this._profileService.selectedRole.getValue()?.nome || '';
	}

	public get formattedDate(): string {
		if (this.currentTimeInMillis === null) {
			return '';
		}

		const dateObj = new Date(this.currentTimeInMillis);

		const formatted = dateObj.toLocaleDateString('it-IT', {
			weekday: 'long',
			day: 'numeric',
			month: 'long'
		});

		return formatted.replace(
			/\b\p{L}/gu,
			letter => letter.toLocaleUpperCase('it-IT')
		);
	}

	public getButtonBackground(color?: string): string {
		return color && /^#[0-9a-fA-F]{6}$/.test(color)
			? `${color}2E`
			: '#f1f5f9';
	}

	private currentTimestamp(): void {
		this._tabsService.getCurrentTimestamp()
			.subscribe(response => {
				this.currentTimeInMillis = response.currentTimeInMillis;
			});
	}

	private fetchData(): void {
		this.isLoading = true;
		let token: any = jwt_decode(this.authService.getAccessToken());
		this.userRoles = (token.realm_access && token.realm_access.roles)? token.realm_access.roles.map(r => r.toLowerCase()): [];
		let structureid = localStorage.getItem(ContextSwitchUtils.getStructureIdLabel());
		this.buttonsService.getAllByContext(structureid).subscribe((res) => {
			this.buttons = res?.sort(
				(a, b) => a.position - b.position
			);

			this.isLoading = false;

		});
	}

	ngOnInit(): void {

		this.currentTimestamp();

		this.activatedRoute.queryParams.subscribe(params => {

			this._spinnerService.show();

			try {

				const structureCode = params['codiceAdt'];

				if (structureCode) {

					this._struttureService.getStructureByAdtCode(structureCode)
						.pipe(catchError((err) => {

							this.fetchData();
							this._spinnerService.hide();
							this._snackbarService.info("Nessuna Struttura trovata per codice ADT");

							return of();

						}))
						.subscribe(structureResponse => {

							if (structureResponse) {

								const selectedStructure = this._profileService.roles.find(r => r.id == structureResponse.id);

								if (selectedStructure) {

									this._profileService.selectedRole.next(selectedStructure);

									localStorage.setItem(ContextSwitchUtils.getStructureIdLabel(), selectedStructure.id);

									this._rcsService.initCache()
										.pipe(catchError((err) => {

											this.fetchData();
											this._spinnerService.hide();
											this._snackbarService.info("Si è verificato un errore imprevisto");

											return of();

										}))
										.subscribe(cacheResponse => {

											this._directiveUtils.refreshProtectedByScopeDirective();
											this.fetchData();
											this._spinnerService.hide();

										});

								} else {

									this._spinnerService.hide();
									this._snackbarService.info("Nessuna Struttura trovata per codice ADT");

								}

							} else {

								this._spinnerService.hide();
								this._snackbarService.info("Nessuna Struttura trovata per codice ADT");

							}

						});

				} else {

					this._spinnerService.hide();
					this.fetchData();

				}

			} catch (err) {

				this.fetchData();
				this._spinnerService.hide();

			}

		});

	}

	ngOnDestroy(): void {
		// setTimeout(() => this.stateService.sidenavRequired = true)
	}

	switchTo(url: string, openInNewTab: boolean): void {
		const urlHasProtocol = url.startsWith('https://') || url.startsWith('http://') || url.startsWith('ftp://');
		if (openInNewTab) {
			if (urlHasProtocol) {
				window.open(url, '_blank');
			} else if (url == 'settings/list') {
				window.open('https://' + url, '_blank');
			} else {
				window.open(environment.services.api.serviceBasePath + '/' + url, '_blank');
			}
		} else {
			if (urlHasProtocol) {
				location.href = url;
			} else if (url.startsWith('www.')) {
				location.href = 'https://' + url;
			} else if (url == 'settings/list') {
				this.router.navigate([url]); // relative url handled by routing
			} else {
				location.href = environment.services.api.serviceBasePath + '/' + url;
			}
		}
	}
}
